module.exports = __webpack_public_path__ + "static/preview-3cc62114fad21e1db28e50a61ef7d9a0.png";